'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _messages = require('common/messages');

var _query = require('utilities/query');

var _categories = require('./categories.html');

var _categories2 = _interopRequireDefault(_categories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _categories2.default,
  bindings: {
    flex: '@',
    layout: '@'
  },
  controller: function () {
    function CategoriesComponent($mdDialog, $scope, $state, CategoryService, ToastService) {
      'ngInject';

      _classCallCheck(this, CategoriesComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        CategoryService: CategoryService,
        ToastService: ToastService
      });
    }

    _createClass(CategoriesComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.columns = [{
          FieldName: 'ProductCategoryName',
          DisplayName: 'Category'
        }, {
          FieldName: 'ProductCount',
          DisplayName: 'Product Count'
        }];

        this.selectedCategories = [];
        this.query = this.CategoryService.getDefaultQuery();
        this.refreshResults();
      }
    }, {
      key: 'onSearchTextChanged',
      value: function onSearchTextChanged(_ref) {
        var searchText = _ref.searchText;

        this.selectedCategories = [];
        this.searchText = searchText;
        this.query = _extends({}, this.query, {
          filter: (0, _odataFilterBuilder2.default)().contains('ProductCategoryName', searchText)
        });

        this.refreshResults();
      }
    }, {
      key: 'onQueryChanged',
      value: function onQueryChanged(_ref2) {
        var query = _ref2.query;

        this.selectedCategories = [];
        this.query = query;
        this.refreshResults();
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults() {
        var _this = this;

        this.promise = this.CategoryService.search(this.query);
        this.promise.then(function (r) {
          _this.categories = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'canDeleteCategories',
      value: function canDeleteCategories(categories) {
        if (!(categories && categories.length)) {
          return false;
        }

        return !categories.some(function (x) {
          return x.ProductCount > 0;
        });
      }
    }, {
      key: 'categoryAdd',
      value: function categoryAdd() {
        var _this2 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          categoryChanged: function categoryChanged($event) {
            return _this2.onCategoryAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <category-form\n                dialog-title="Add New Category"\n                submit-title="Add Category"\n                category-changed="categoryChanged($event)">\n              </category-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onCategoryAdded',
      value: function onCategoryAdded(_ref3) {
        var _this3 = this;

        var category = _ref3.category;

        this.CategoryService.add(category).then(function () {
          _this3.$mdDialog.hide();
          _this3.refreshResults();
          _this3.ToastService.showSuccess(_messages.CATEGORY_ADDED);
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        });
      }
    }, {
      key: 'categoryEdit',
      value: function categoryEdit(category) {
        var _this4 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          categoryChanged: function categoryChanged($event) {
            return _this4.onCategoryEdited($event);
          },
          category: _angular2.default.copy(category)
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <category-form\n                category="category"\n                dialog-title="Edit Category"\n                submit-title="Save Changes"\n                category-changed="categoryChanged($event)">\n              </category-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'categoryDelete',
      value: function categoryDelete(categories) {
        var _this5 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected categories cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = categories.length - 1; i >= 0; i -= 1) {
            promises.push(_this5.CategoryService.delete(categories[i].ProductCategoryId));
          }

          Promise.all(promises).then(function () {
            _this5.ToastService.showSuccess(_messages.CATEGORY_DELETED);
            _this5.selectedCategories = [];
            _this5.refreshResults();
          }).catch(function (error) {
            if (error.statusText === 'Bad Request' && error.data && error.data.Message) {
              _this5.ToastService.showError(error, error.data.Message);
            } else {
              _this5.ToastService.showError(error);
            }
          });
        });
      }
    }, {
      key: 'onCategoryEdited',
      value: function onCategoryEdited(_ref4) {
        var _this6 = this;

        var category = _ref4.category;

        this.CategoryService.update(category).then(function () {
          _this6.$mdDialog.hide();
          _this6.selectedCategories = [];
          _this6.refreshResults();
          _this6.ToastService.showSuccess(_messages.CATEGORY_EDITED);
        }).catch(function (error) {
          return _this6.ToastService.showError(error);
        });
      }
    }]);

    return CategoriesComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/categories/categories.component.js